import{_ as r}from"./_defineProperty.js";var e=r;var a=function(r,a,o){"__proto__"==a&&e?e(r,a,{configurable:!0,enumerable:!0,value:o,writable:!0}):r[a]=o};export{a as _};
